module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2fa"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _vm._v("CONTENTS")]), _vm._v(" "), _c('div', {
    staticClass: "hide"
  }, [_c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "hide"
  }), _vm._v(" "), _c('div', {
    staticClass: "hide"
  }), _vm._v(" "), _c('div', {
    staticClass: "hide"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Acknowledgments"
    }
  }, [_c('i', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Introduction"
    }
  }, [_c('i', [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Part01"
    }
  }, [_c('b', [_vm._v("— One —"), _c('br'), _vm._v("Uprooted: When Life’s Landscape Changes")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter01"
    }
  }, [_c('i', [_vm._v("Life Is Short, Eternity Is Long")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02"
    }
  }, [_c('i', [_vm._v("More Than We Can Handle")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter03"
    }
  }, [_c('i', [_vm._v("Out of the Pit")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter04"
    }
  }, [_c('i', [_vm._v("Through Waters Deep")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter05"
    }
  }, [_c('i', [_vm._v("Not Ready to Celebrate")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter06"
    }
  }, [_c('i', [_vm._v("Coping")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter07"
    }
  }, [_c('i', [_vm._v("Year of Fear")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter08"
    }
  }, [_c('i', [_vm._v("Identity")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter09"
    }
  }, [_c('i', [_vm._v("Unwelcome Changes")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The Interpreter")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Part02",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("— Two —"), _c('br'), _vm._v("Sowing Seeds: Cultivating Truth and Faith")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Trust Despite Troubles")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Searching for Peace")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Lifeline Theology")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Longing for Transformation")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The Sacrifice of Praise")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Remembering Matters")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("It’s Not Our Story")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Ugly Turned Beautiful")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Who Knows?")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("When We Can’t Fix It")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Part03",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("— Three —"), _c('br'), _vm._v("Pulling Weeds: Digging Out That Which Entangles")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Do You Love Me?")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Good-Bye, Guilt!")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The Reins of Sin")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Saying No to Idolatry")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter25",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("When Churches Hurt")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter26",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Self-Sabotage")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter27",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Sibling Rivalry")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter28",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Mind Games")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter29",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Confronting My Friends—and Myself")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter30",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("I Love Horses More Than You")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Part04",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("— Four —"), _c('br'), _vm._v("Parched: When Hope Withers")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter31",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Waiting Out the Storm")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter32",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("“I Can’t Keep Him Alive”")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter33",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The Hard Work of Healing")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter34",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Asking for More")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter35",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Crushed Spirit")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter36",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Loss and the Hope of Heaven")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter37",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Huddle Up")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter38",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The Towel")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter39",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("From Darkness into Light")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter40",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("What Do We Do with God?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Part05",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("— Five —"), _c('br'), _vm._v("Drenched: Nourishing the Soul")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter41",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("A Family Who Worships")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter42",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Speak Life")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter43",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Lack of Sleep Is a Form of Torture")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter44",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Strength for the Fight")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter45",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Held Together")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter46",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Contagious Joy")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter47",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Compassionate Father")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter48",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Sibling Therapy")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter49",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Indispensable")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter50",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Deep Caregiver Love")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Part06",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("— Six —"), _c('br'), _vm._v("Sunlit: Turning Toward the Son")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter51",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Eyes Wide Open")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter52",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Secret Keeper")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter53",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Unknown Protections")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter54",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Facing the Future")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter55",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Children of God")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter56",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The Ride of Your Life")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter57",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Sovereign Moments")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter58",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("What’s in a Name?")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter59",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Medical Debt, Spiritual Debt")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter60",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Heavenly Dwelling")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Part07",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("— Seven —"), _c('br'), _vm._v("Pruned: When Pain Produces Fruit")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter61",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Gloriously Dependent")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter62",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("He Hates Being Cleaned")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter63",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Can We Have a Better Marriage?")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter64",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Pride Killer")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter65",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Brokenness")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter66",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Keep Walking")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter67",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The Joy of Surrender")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter68",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Don’t Panic!")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter69",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Rescued Hearts")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Part08",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("— Eight —"), _c('br'), _vm._v("Branching Out: Touching Others’ Lives Through the Journey")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter70",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Speak Up")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter71",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Friends in the Fire")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter72",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Dusty Doorways")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter73",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Waves of Kindness")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter74",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Words That Matter")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter75",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The Gift of Presence")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter76",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Buddy System")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter77",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Jill’s House")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter78",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Share Your Story")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Backmatter",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Knowing Jesus Personally")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Resources",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Resources")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Authors",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("About the Authors")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0df69bd0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Contents.vue
// module id = 72
// module chunks = 0